import { Button, Modal, Table } from "antd";
import { billingOffice } from "common/Constants";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { useQueryState } from "hooks/useQueryState";
import { getClientDetailData, useClientDetailSource } from "hooks/useClientsListSource";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { getUserList } from "redux/selectors";
import styled from "styled-components";

const columns = [
  {
    title: "S.No",
    dataIndex: "sno",
    key: "sno",
    render: (_, record) => <>{record.sno}</>,
    width: "5%",
  },
  {
    title: "Column 1",
    dataIndex: "column1",
    key: "column1",
    onCell: (record) => ({ colSpan: record.column1.colSpan }),
    render: (text, record) => record.column1.value,
    width: "25%",
  },
  {
    title: "Column 2",
    dataIndex: "column2",
    key: "column2",
    onCell: (record) => ({ colSpan: record.column2.colSpan }),
    render: (text, record) => record.column2.value,
    width: "35%",
  },
  {
    title: "Column 3",
    dataIndex: "column3",
    key: "column3",
    onCell: (record) => ({ colSpan: record.column3.colSpan }),
    render: (text, record) => record.column3.value,
    className: "fw-bold",
    width: "15%",
  },
  {
    title: "Column 4",
    dataIndex: "column4",
    key: "column4",
    onCell: (record) => ({ colSpan: record.column4.colSpan }),
    render: (text, record) => record.column4.value,
    align: "right",
    width: "20%",
  },
];

const accountsColumns = [
  {
    title: "Column 1",
    dataIndex: "column1",
    key: "column1",
    onCell: (record) => ({ colSpan: record.column1.colSpan }),
    render: (text, record) => record.column1.value,
    width: "25%",
  },
  {
    title: "Column 2",
    dataIndex: "column2",
    key: "column2",
    onCell: (record) => ({ colSpan: record.column2.colSpan }),
    render: (text, record) => record.column2.value,
    width: "25%",
  },
  {
    title: "Column 3",
    dataIndex: "column3",
    key: "column3",
    onCell: (record) => ({ colSpan: record.column3.colSpan }),
    render: (text, record) => record.column3.value,
    width: "25%",
  },
  {
    title: "Column 4",
    dataIndex: "column4",
    key: "column4",
    onCell: (record) => ({ colSpan: record.column4.colSpan }),
    render: (text, record) => record.column4.value,
    align: "right",
    width: "25%",
  },
];

const BillingInvoice = ({ billingInvoiceData, open, handleClose,engagementDataForDirectPreview,formValues }) => {
  const userList = useSelector(getUserList);
  const clientId = billingInvoiceData?.clientcode;
  const getClientDetailSource = useClientDetailSource();
      
  const engagementId = billingInvoiceData?.engagementid;

  const { key, url } = getClientDetailSource(clientId);
  const { data: clientDataRes } = useFetch(key, url, { endpoint: !!clientId, });

  const { key: engagementKey, url: engagementUrl } =
    queryKeys.getEngagementById(engagementId);

  const { isFetched } = useQueryState(key);

  const { data: engagementDataRes } = useFetch(engagementKey, engagementUrl, {
    enabled: !isFetched && !!engagementId,
  });

  const engagementData = engagementDataRes?.data ? engagementDataRes?.data : engagementDataForDirectPreview;

  const clientData = getClientDetailData(clientDataRes);

  const billingOfficeData = billingOffice.find(
    item => item.id == engagementData?.financial_resourcePlan?.billingOffice) ?? { id: null, name: "", tax: 0 };

  const billingOfficeName = billingOfficeData?.name;

  const competency = engagementData?.client?.competency;

  const serviceLine = engagementData?.client?.serviceLine;

  const clientName = engagementData?.client?.clientName || clientData?.registeredName;

  const address = clientData?.bdo_registeredaddress ? clientData?.bdo_registeredaddress : billingInvoiceData?.address;

  const registeredNumber = billingInvoiceData?.loerefno;

  const pinNumber = clientData?.bdo_pin ? clientData?.bdo_pin : billingInvoiceData?.bdo_pin;

  const contactPerson = billingInvoiceData?.contactperson ? billingInvoiceData?.contactperson : billingInvoiceData?.contactpersonid;
  const contactPersonAc = billingInvoiceData?.contactpersonac ? billingInvoiceData?.contactpersonac : billingInvoiceData?.contactpersonacid;

  const clientEmailAddress = clientData?.emailaddress1 ? clientData?.emailaddress1 : billingInvoiceData?.emailaddress1;

  const description = billingInvoiceData?.description;

  const billingdate = billingInvoiceData?.billingdate;

  const cleanAmount = (value) => {
    if (!value) return 0;
    return parseInt(String(value).replace(/[$,]/g, ""), 10) || 0;
  };

  const fees = cleanAmount(billingInvoiceData?.amount);
  const amountForVAT = cleanAmount(formValues?.amount);

  const heading = fees ? fees : amountForVAT > 0 ? "REQUEST FOR FEE NOTE" : "REQUEST FOR CREDIT NOTE";

  const disbursmentCalc = billingInvoiceData?.claims?.reduce(
    (acc, claim) =>
      claim.type !== "Subcontract" ? acc + (parseInt(claim?.amount) || 0) : acc,
    0
  );
  const Disbursement = disbursmentCalc || 0;

  const subContractCalc = billingInvoiceData?.claims?.reduce((acc, claim) => {
    return claim.type === "Subcontract"
      ? acc + (parseInt(claim?.amount) || 0)
      : acc;
  }, 0);

  const Subcontract = subContractCalc || 0;

  // const isVat = (billingInvoiceData?.vat && billingInvoiceData?.vat === "VAT") || formValues?.vat === "VAT";

  // const totalExcludingTax = (fees || amountForVAT) + Disbursement + Subcontract;

  // const taxPercentage = billingOfficeData?.tax || 0.16;

  // const tax = isVat ? (totalExcludingTax * taxPercentage).toFixed(2) : 0.0;

  // const normalTax = isVat? Number((totalExcludingTax * taxPercentage).toFixed(2)): 0;

  // const total = totalExcludingTax + parseFloat(tax);

  const taxPercentage = billingOfficeData?.tax || 0.16;
  const billingFeeBase = Number(formValues?.amount) || fees;
  // Billing is VAT only if explicitly marked VAT
  const isBillingVat =
    billingInvoiceData?.vat === "VAT" || formValues?.vat === "VAT";

  // Claims VAT: sum only claims individually marked vat=true
  const vatEligibleClaimsAmount = (billingInvoiceData?.claims ?? []).reduce(
    (acc, claim) => (claim.vat === true ? acc + (parseInt(claim?.amount) || 0) : acc),
    0
  );

  // VAT applied only where VAT is set — never double-applied
  const vatFromBilling = isBillingVat ? billingFeeBase * taxPercentage : 0;
  const vatFromClaims = vatEligibleClaimsAmount * taxPercentage;
  const normalTax = Number((vatFromBilling + vatFromClaims).toFixed(2));

  const totalExcludingTax = billingFeeBase + Disbursement + Subcontract;
  const total = totalExcludingTax + normalTax;


  const partnerName = userList?.find(
    (user) => user.userid === engagementData?.stakeHolder?.partner
  )?.fullname;

  const personInCharge = userList?.find(
    (user) => user.userid === engagementData?.stakeHolder?.personIncharge
  )?.fullname;

  const billingStatus = billingInvoiceData?.statusname;
  const approvedby = billingInvoiceData?.engagementPartner;
  const approvedbyName = userList?.find(
    (user) => user?.userid === approvedby
  )?.fullname;

  let specialVatAmount = 0;
  let specialAdditionalTax = 0;
  let specialTotalTax = 0;
  let specialTotal = 0;
  let specialtotamount = 0;

  //   const numericFees = Number(fees) || 0;   
  //  const baseamount = Number((formValues?.amount) || numericFees);

  //   if ((billingOfficeData.id === 22 || billingOfficeData.id === 21) && isVat) { 
  //      specialVatAmount = Number(formValues?.amount * taxPercentage || numericFees * taxPercentage);
  //      specialtotamount = specialVatAmount + Number(Disbursement) + Number(Subcontract);
  //      const taxAmount = specialtotamount * 0.05;
  //      if (taxAmount % 1 === 0) {
  //        specialAdditionalTax = taxAmount.toString();
  //      } else {
  //        specialAdditionalTax = taxAmount.toFixed(2);
  //      }
  //      specialTotal = baseamount + specialtotamount + Number(specialAdditionalTax);
  //      }

  // REPLACE WITH:
  const isSpecialOffice = billingOfficeData.id === 22 || billingOfficeData.id === 21;

  if (isSpecialOffice) {
    // Apply VAT only where set — same selective logic as normal offices
    specialVatAmount = Number((vatFromBilling + vatFromClaims).toFixed(2));
    specialtotamount = specialVatAmount + Number(Disbursement) + Number(Subcontract);
    const taxAmount = specialtotamount * 0.05;
    specialAdditionalTax = taxAmount % 1 === 0 ? taxAmount.toString() : taxAmount.toFixed(2);
    specialTotal = billingFeeBase + specialtotamount + Number(specialAdditionalTax);
  }

  const formatAmountINR = (amount) => {
    const cleaned = String(amount).replace(/[^0-9.-]/g, ""); // Remove $, commas etc.
    const parsed = Number(cleaned.split(".")[0]); // Take only the integer part
    if (isNaN(parsed)) return "0";
    return new Intl.NumberFormat("en-US").format(parsed);
  };

  const dataSource = [
    {
      sno: 1,
      column1: { value: "Department", colSpan: 1 },
      column2: { value: competency, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: 2,
      column1: { value: "Company", colSpan: 1 },
      column2: { value: billingOfficeName, colSpan: 1 },
      column3: { value: "Date", colSpan: 1 },
      column4: { value: billingdate ? moment(billingdate).format("DD MMM YYYY") : "-", colSpan: 1 },
    },
    {
      sno: 3,
      column1: { value: "Service Line", colSpan: 1 },
      column2: { value: serviceLine, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: 4,
      column1: { value: "Client Name", colSpan: 1 },
      column2: { value: clientName, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: 5,
      column1: { value: "Address", colSpan: 1 },
      column2: { value: address, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: 6,
      column1: { value: "Contact Person", colSpan: 1 },
      column2: { value: contactPerson, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: "",
      column1: { value: "Contact Person A/C", colSpan: 1 },
      column2: { value: contactPersonAc, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: "",
      column1: { value: "Email addresses", colSpan: 1 },
      column2: { value: clientEmailAddress, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },

    {
      sno: "",
      column1: { value: "Engagement ID", colSpan: 1 },
      column2: { value: engagementData?.engagementId ?? "-", colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: "",
      column1: { value: "Billing ID", colSpan: 1 },
      column2: { value: billingInvoiceData?.billingid ?? "-", colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: 7,
      column1: { value: "LOE Ref No", colSpan: 1 },
      column2: { value: registeredNumber, colSpan: 1 },
      column3: { value: "Client PIN", colSpan: 1 },
      column4: { value: pinNumber, colSpan: 1 },
    },
    {
      sn: 8,
      column1: { value: "Code (Time sheet system)", colSpan: 1 },
      column2: { value: "", colSpan: 1 },
      column3: { value: "Currency", colSpan: 1 },
      column4: {
        value: engagementData?.financial_resourcePlan?.currency,
        colSpan: 1,
      },
    },
    {
      sno: 9,
      column1: { value: "Description of Services Rendered", colSpan: 1 },
      column2: { value: formValues?.description ? formValues?.description : description, colSpan: 3 },
      column3: { value: "", colSpan: 0 },
      column4: { value: "", colSpan: 0 },
    },
    {
      sno: 10,
      column1: { value: "Fees", colSpan: 1 },
      column2: { value: "", colSpan: 1 },
      column3: { value: "", colSpan: 1 },
      column4: { value: formatAmountINR(formValues?.amount || fees), colSpan: 1 },
    },
    {
      sno: "",
      column1: { value: "Disbursement(Claims)", colSpan: 1 },
      column2: { value: "", colSpan: 1 },
      column3: { value: "", colSpan: 1 },
      column4: { value: formatAmountINR(Disbursement), colSpan: 1 },
    },
    {
      sno: "",
      column1: { value: "Subcontract(Claims)", colSpan: 1 },
      column2: { value: "", colSpan: 1 },
      column3: { value: "", colSpan: 1 },
      column4: { value: formatAmountINR(Subcontract), colSpan: 1 },
    },
    {
      sno: "",
      column1: { value: `VAT - ${taxPercentage * 100}%`, colSpan: 1 },
      column2: { value: "", colSpan: 1 },
      column3: { value: "", colSpan: 1 },
      column4: {
        value: formatAmountINR(
          (billingOfficeData.id === 22 || billingOfficeData.id === 21 ? specialVatAmount : normalTax).toFixed(2)
        ),
        colSpan: 1,
      },
    },

    ...(billingOfficeData.id === 22 || billingOfficeData.id === 21
      ? [{
        sno: "",
        column1: { value: "Additional tax on VAT", colSpan: 1 },
        column2: { value: "", colSpan: 1 },
        column3: { value: "", colSpan: 1 },
        column4: {
          value: Number(specialAdditionalTax || 0).toFixed(2),
          colSpan: 1,
        },
      }]
      : []),

    {
      sno: 11,
      column1: { value: "TOTAL", colSpan: 1 },
      column2: { value: "", colSpan: 1 },
      column3: { value: "", colSpan: 1 },
      column4: {
        value: (
          billingOfficeData.id === 22 || billingOfficeData.id === 21
            ? Number(specialTotal)
            : Number(total)
        ).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-",
        colSpan: 1,
      },
    },
    {
      sno: 12,
      column1: { value: "Name of Incharge", colSpan: 1 },
      column2: { value: "", colSpan: 1 },
      column3: { value: "", colSpan: 1 },
      column4: { value: "", colSpan: 1 },
    },
    {
      sno: "",
      column1: { value: "Partner", colSpan: 1 },
      column2: { value: partnerName, colSpan: 1 },
      column3: { value: "Senior", colSpan: 1 },
      column4: { value: "", colSpan: 1 },
    },
    {
      sno: "",
      column1: { value: "Manager", colSpan: 1 },
      column2: { value: personInCharge, colSpan: 1 },
      column3: { value: "Semi Senior", colSpan: 1 },
      column4: { value: "", colSpan: 1 },
    },
    // {
    //   sno: "",
    //   column1: { value: "Assistant Manager", colSpan: 1 },
    //   column2: { value: "Semi Senior", colSpan: 1 },
    //   column3: { value: "", colSpan: 1 },
    //   column4: { value: "", colSpan: 1 },
    // },
    // {
    //   sno: "",
    //   column1: { value: "Supervisors", colSpan: 1 },
    //   column2: { value: "", colSpan: 1 },
    //   column3: { value: "", colSpan: 1 },
    //   column4: { value: "", colSpan: 1 },
    // },
    {
      sno: 13,
      column1: {
        value:
          "Staff responsible for cash collection for this job and debtor's ledger reconciliation",
        colSpan: 2,
      },
      column2: { value: "", colSpan: 0 },
      column3: { value: "", colSpan: 1 },
      column4: { value: "", colSpan: 1 },
    },
  ];

  const printComponentRef = React.useRef(null);

  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
    bodyClass: "p-3",
  });

  return (
    <StyledModal
      open={open}
      onCancel={handleClose}
      title={billingOfficeName}
      width={1200}
      footer={null}
      closable={true}
      maskClosable={false}
      centered={true}
    >
      <BillingInvoiceWrap ref={printComponentRef}>
        <div className="invoice-heading">
          INVOICE/CREDIT NOTE Raising Request
        </div>
        <div>
          <div className="heading">{heading}</div>

          <BillingInvoiceTable
            columns={columns}
            dataSource={dataSource}
            bordered={true}
            pagination={false}
            showHeader={false}
          />
          <div className="section-row">
            <div className="left">{billingStatus ? billingStatus : "Pending"}</div>
            <div className="right">
              {billingStatus === "Approved by Partner" ||
                billingStatus === "Approved by Finance"
                ? approvedbyName
                : "-"}
            </div>
          </div>

          <div className="section-row">
            <div className="left">Signature</div>
            <div className="right">{billingdate ? moment(billingdate).format("DD MMM YYYY") : "-"}</div>
          </div>

          <div className="accepatance">
            I, certify that the above amount billed is in accordance with the
            engagement letter and/or the assignment has been completed at client
            satisfaction.
          </div>

          {/* <div className="accounts-heading">For accounts department</div>

        <BillingInvoiceTable
          columns={accountsColumns}
          dataSource={[
            {
              column1: { value: "Batch number", colSpan: 1 },
              column2: { value: "", colSpan: 1 },
              column3: { value: "PROFORMA INVOICE Number", colSpan: 1 },
              column4: { value: "", colSpan: 1 },
            },
          ]}
          bordered={true}
          pagination={false}
          showHeader={false}
        />

        <div className="complete">
          This completed and signed off document will be filed at
          \\Bdoserver\41-FEE NOTES\200-BDO EA invoice raising reques
        </div> */}
        </div>
      </BillingInvoiceWrap>
      <div
        style={{ display: "flex", gap: "8px", justifyContent: "end" }}
        className="mb-3 mt-2"
      >
        <div>
          <Button type="primary" className="ms-0" onClick={handlePrint}>
            Print Invoice
          </Button>
        </div>
      </div>
    </StyledModal>
  );
};

export default BillingInvoice;

const BillingInvoiceWrap = styled.div`
  .invoice-heading {
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: start;
  }
  .heading {
    font-weight: 600;
    margin-bottom: 10px;
    text-align: center;
  }
  .section-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-weight: 600;
    .right {
      padding: 10px 40px 10px 40px;
      border-bottom: 2px solid #000;
      min-width: 160px;
    }
  }
  .accepatance {
    font-weight: 600;
    margin-top: 20px;
  }
  .accounts-heading {
    font-size: 17px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: start;
  }
  .complete {
    font-size: 14px;
    font-weight: 500;
    margin-top: 20px;
    text-align: center;
  }
`;

const BillingInvoiceTable = styled(Table)`
  .ant-table-cell.nowrap {
    white-space: nowrap;
  }
  .ant-table-cell.border-right-none {
    border-right: none !important;
  }
  .ant-table-cell.border-bottom-none {
    border-bottom: none;
  }
  .ant-table-cell {
    padding: 6px 10px !important;
    font-size: 14px;
    font-weight: 500;
  }
  .ant-table-thead > tr > th {
    overflow-wrap: normal;
  }
  .ant-table-cell:has(.extra-section) {
    border-bottom: 5px solid #f0f0f0;
  }
  margin-bottom: 20px;
`;

const StyledModal = styled(Modal)`
  .ant-modal-close-x {
    .anticon-close.ant-modal-close-icon,
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .ant-modal-header {
    border-bottom: none;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .ant-modal-title {
    font-weight: 500;
    text-align: left;
    color: #1b1b1b;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  .anticon {
    color: #000000;
    width: 14px;
    height: 14px;
  }
  .ant-modal-body {
    padding-top: 0px;
    height: 85vh;
    overflow-y: scroll;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-btn-text:focus,
  .ant-btn-text:hover {
    background: #26a4ff;
    color: #ffffff;
  }
  .ant-checkbox.ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: #02b209 !important;
      border-color: #02b209 !important;
    }
  }
  .ant-upload-span {
    cursor: pointer;
  }
`;
